import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">用户评价</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            听听影迷们对天堂影院的真实使用感受
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentsData.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-100 border border-background-200/60 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.date}</div>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{item.content}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}